import * as Permissions from '@/js/libs/generated/permissions/types';
import * as Types from './types';
export var MessageDtoFailureReasonInline;
(function (MessageDtoFailureReasonInline) {
    MessageDtoFailureReasonInline["PROMPT_TOO_LARGE"] = "PROMPT_TOO_LARGE";
    MessageDtoFailureReasonInline["MODEL_UNAVAILABLE"] = "MODEL_UNAVAILABLE";
    MessageDtoFailureReasonInline["MODEL_TEMPORARILY_UNAVAILABLE"] = "MODEL_TEMPORARILY_UNAVAILABLE";
    MessageDtoFailureReasonInline["TOOL_LIMIT_REACHED"] = "TOOL_LIMIT_REACHED";
})(MessageDtoFailureReasonInline || (MessageDtoFailureReasonInline = {}));
export var MessageDtoRoleInline;
(function (MessageDtoRoleInline) {
    MessageDtoRoleInline["USER"] = "USER";
    MessageDtoRoleInline["ASSISTANT"] = "ASSISTANT";
})(MessageDtoRoleInline || (MessageDtoRoleInline = {}));
export var MessageDtoStatusInline;
(function (MessageDtoStatusInline) {
    MessageDtoStatusInline["PENDING"] = "PENDING";
    MessageDtoStatusInline["IN_PROGRESS"] = "IN_PROGRESS";
    MessageDtoStatusInline["COMPLETED"] = "COMPLETED";
    MessageDtoStatusInline["FAILED"] = "FAILED";
})(MessageDtoStatusInline || (MessageDtoStatusInline = {}));
/** A fixed AdConsole shortcut that opens the chat on a templated prompt: MEETING_PREP is Meeting Prep, opened from an account; CAMPAIGN_REVIEW is Campaign Review, opened from a campaign. */
export var QuickEntry;
(function (QuickEntry) {
    QuickEntry["MEETING_PREP"] = "MEETING_PREP";
    QuickEntry["CAMPAIGN_REVIEW"] = "CAMPAIGN_REVIEW";
})(QuickEntry || (QuickEntry = {}));
/** An agent's classification. REGULAR and PRESENTATION agents appear in the chat selector; REPORTING agents drive the conversational report-spec tools and are fetched only by the reporting context. */
export var AgentCategory;
(function (AgentCategory) {
    AgentCategory["REGULAR"] = "REGULAR";
    AgentCategory["PRESENTATION"] = "PRESENTATION";
    AgentCategory["REPORTING"] = "REPORTING";
})(AgentCategory || (AgentCategory = {}));
export var TargetingPersonaFit;
(function (TargetingPersonaFit) {
    TargetingPersonaFit["HIGH"] = "HIGH";
    TargetingPersonaFit["MEDIUM"] = "MEDIUM";
    TargetingPersonaFit["LOW"] = "LOW";
})(TargetingPersonaFit || (TargetingPersonaFit = {}));
export var TargetingPageReadStatus;
(function (TargetingPageReadStatus) {
    TargetingPageReadStatus["OK"] = "OK";
    TargetingPageReadStatus["THIN"] = "THIN";
    TargetingPageReadStatus["BLOCKED"] = "BLOCKED";
    TargetingPageReadStatus["ERROR"] = "ERROR";
})(TargetingPageReadStatus || (TargetingPageReadStatus = {}));
export var TargetingProfileField;
(function (TargetingProfileField) {
    TargetingProfileField["PRODUCT_OR_SERVICE"] = "PRODUCT_OR_SERVICE";
    TargetingProfileField["CATEGORY"] = "CATEGORY";
    TargetingProfileField["BRAND"] = "BRAND";
    TargetingProfileField["PRICE_TIER"] = "PRICE_TIER";
    TargetingProfileField["AUDIENCE_BENEFIT"] = "AUDIENCE_BENEFIT";
    TargetingProfileField["COMPETITORS"] = "COMPETITORS";
})(TargetingProfileField || (TargetingProfileField = {}));
export var KeywordLanguage;
(function (KeywordLanguage) {
    KeywordLanguage["en"] = "en";
    KeywordLanguage["de"] = "de";
    KeywordLanguage["fr"] = "fr";
    KeywordLanguage["it"] = "it";
})(KeywordLanguage || (KeywordLanguage = {}));
export var TargetingConfigField;
(function (TargetingConfigField) {
    TargetingConfigField["NAME"] = "NAME";
    TargetingConfigField["KEYWORDS"] = "KEYWORDS";
    TargetingConfigField["THRESHOLD"] = "THRESHOLD";
    TargetingConfigField["IAB_CATEGORIES"] = "IAB_CATEGORIES";
    TargetingConfigField["SENTIMENTS"] = "SENTIMENTS";
    TargetingConfigField["EXACT_INCLUSION_KEYWORDS"] = "EXACT_INCLUSION_KEYWORDS";
    TargetingConfigField["EXACT_EXCLUSION_KEYWORDS"] = "EXACT_EXCLUSION_KEYWORDS";
    TargetingConfigField["GENDERS"] = "GENDERS";
    TargetingConfigField["AGE_GROUPS"] = "AGE_GROUPS";
    TargetingConfigField["INCOME_LEVELS"] = "INCOME_LEVELS";
    TargetingConfigField["BROWSER_IDS"] = "BROWSER_IDS";
    TargetingConfigField["OPERATING_SYSTEM_FAMILY_IDS"] = "OPERATING_SYSTEM_FAMILY_IDS";
})(TargetingConfigField || (TargetingConfigField = {}));
export var AudienceGender;
(function (AudienceGender) {
    AudienceGender["MALE"] = "MALE";
    AudienceGender["FEMALE"] = "FEMALE";
})(AudienceGender || (AudienceGender = {}));
export var AgeGroup;
(function (AgeGroup) {
    AgeGroup["AGE_18_24"] = "AGE_18_24";
    AgeGroup["AGE_25_34"] = "AGE_25_34";
    AgeGroup["AGE_35_44"] = "AGE_35_44";
    AgeGroup["AGE_45_54"] = "AGE_45_54";
    AgeGroup["AGE_55_64"] = "AGE_55_64";
    AgeGroup["AGE_65_PLUS"] = "AGE_65_PLUS";
})(AgeGroup || (AgeGroup = {}));
/** Relative income affinity of the article audience, without monetary thresholds. */
export var IncomeLevel;
(function (IncomeLevel) {
    IncomeLevel["LOW"] = "LOW";
    IncomeLevel["MID"] = "MID";
    IncomeLevel["HIGH"] = "HIGH";
    IncomeLevel["TOP"] = "TOP";
})(IncomeLevel || (IncomeLevel = {}));
export var TargetingPriceTier;
(function (TargetingPriceTier) {
    TargetingPriceTier["BUDGET"] = "BUDGET";
    TargetingPriceTier["MID"] = "MID";
    TargetingPriceTier["PREMIUM"] = "PREMIUM";
    TargetingPriceTier["LUXURY"] = "LUXURY";
    TargetingPriceTier["ENTERPRISE"] = "ENTERPRISE";
    TargetingPriceTier["UNLISTED"] = "UNLISTED";
})(TargetingPriceTier || (TargetingPriceTier = {}));
export var TargetingPageType;
(function (TargetingPageType) {
    TargetingPageType["PRODUCT"] = "PRODUCT";
    TargetingPageType["CATEGORY"] = "CATEGORY";
    TargetingPageType["BRAND_HOMEPAGE"] = "BRAND_HOMEPAGE";
    TargetingPageType["CAMPAIGN"] = "CAMPAIGN";
    TargetingPageType["EDITORIAL"] = "EDITORIAL";
    TargetingPageType["UNKNOWN"] = "UNKNOWN";
})(TargetingPageType || (TargetingPageType = {}));
export var TargetingExtractionQuality;
(function (TargetingExtractionQuality) {
    TargetingExtractionQuality["RICH"] = "RICH";
    TargetingExtractionQuality["PARTIAL"] = "PARTIAL";
    TargetingExtractionQuality["THIN"] = "THIN";
})(TargetingExtractionQuality || (TargetingExtractionQuality = {}));
export var TargetingSensitiveCategory;
(function (TargetingSensitiveCategory) {
    TargetingSensitiveCategory["NONE"] = "NONE";
    TargetingSensitiveCategory["FINANCIAL"] = "FINANCIAL";
    TargetingSensitiveCategory["HEALTH"] = "HEALTH";
    TargetingSensitiveCategory["GAMBLING"] = "GAMBLING";
    TargetingSensitiveCategory["ALCOHOL"] = "ALCOHOL";
    TargetingSensitiveCategory["POLITICAL"] = "POLITICAL";
    TargetingSensitiveCategory["OTHER"] = "OTHER";
})(TargetingSensitiveCategory || (TargetingSensitiveCategory = {}));
export var TargetingKeywordLayer;
(function (TargetingKeywordLayer) {
    TargetingKeywordLayer["DESCRIPTIVE"] = "DESCRIPTIVE";
    TargetingKeywordLayer["AFFINITY"] = "AFFINITY";
})(TargetingKeywordLayer || (TargetingKeywordLayer = {}));
/** How an affinity keyword relates to the product: COMPLEMENTARY is bought or used alongside it, TRIGGER_EVENT opens the purchase window, USE_CONTEXT is the situation it is used in, DECISION_RESEARCH is what the buyer reads while deciding, IDENTITY_PROXY is a topic this buyer is over-represented in with no product connection. DESCRIPTIVE keywords describe the product itself. */
export var TargetingKeywordRelation;
(function (TargetingKeywordRelation) {
    TargetingKeywordRelation["DESCRIPTIVE"] = "DESCRIPTIVE";
    TargetingKeywordRelation["COMPLEMENTARY"] = "COMPLEMENTARY";
    TargetingKeywordRelation["TRIGGER_EVENT"] = "TRIGGER_EVENT";
    TargetingKeywordRelation["USE_CONTEXT"] = "USE_CONTEXT";
    TargetingKeywordRelation["DECISION_RESEARCH"] = "DECISION_RESEARCH";
    TargetingKeywordRelation["IDENTITY_PROXY"] = "IDENTITY_PROXY";
})(TargetingKeywordRelation || (TargetingKeywordRelation = {}));
export var RecommendationConfidence;
(function (RecommendationConfidence) {
    RecommendationConfidence["HIGH"] = "HIGH";
    RecommendationConfidence["MEDIUM"] = "MEDIUM";
    RecommendationConfidence["LOW"] = "LOW";
})(RecommendationConfidence || (RecommendationConfidence = {}));
/** A getAgents filter that expands to a set of categories: CHAT -> [REGULAR, PRESENTATION], REPORT -> [REPORTING], ALL -> every category. */
export var AgentCategoryBundle;
(function (AgentCategoryBundle) {
    AgentCategoryBundle["ALL"] = "ALL";
    AgentCategoryBundle["CHAT"] = "CHAT";
    AgentCategoryBundle["REPORT"] = "REPORT";
})(AgentCategoryBundle || (AgentCategoryBundle = {}));
/** Discriminator for a message's structured (non-text) output, carried as the type of the structuredOutput envelope. Add a value here for each new output kind. REPORT_SPEC and CLARIFICATION are produced by the assistant; CLARIFICATION_ANSWER is attached by the client to the user reply that answers a CLARIFICATION. */
export var MessageOutputType;
(function (MessageOutputType) {
    MessageOutputType["REPORT_SPEC"] = "REPORT_SPEC";
    MessageOutputType["CLARIFICATION"] = "CLARIFICATION";
    MessageOutputType["CLARIFICATION_ANSWER"] = "CLARIFICATION_ANSWER";
})(MessageOutputType || (MessageOutputType = {}));
export var ModelTypeEnum;
(function (ModelTypeEnum) {
    ModelTypeEnum["TEXT"] = "TEXT";
    ModelTypeEnum["IMAGE"] = "IMAGE";
    ModelTypeEnum["VIDEO"] = "VIDEO";
})(ModelTypeEnum || (ModelTypeEnum = {}));
export var TargetingMode;
(function (TargetingMode) {
    TargetingMode["EXCLUDE"] = "EXCLUDE";
    TargetingMode["INCLUDE"] = "INCLUDE";
})(TargetingMode || (TargetingMode = {}));
export var LanguageCode;
(function (LanguageCode) {
    LanguageCode["DE"] = "DE";
    LanguageCode["EN"] = "EN";
    LanguageCode["FR"] = "FR";
    LanguageCode["IT"] = "IT";
})(LanguageCode || (LanguageCode = {}));
export var FormOfCommunication;
(function (FormOfCommunication) {
    FormOfCommunication["INFORMAL"] = "INFORMAL";
    FormOfCommunication["FORMAL"] = "FORMAL";
})(FormOfCommunication || (FormOfCommunication = {}));
export var ContactRole;
(function (ContactRole) {
    ContactRole["SALES"] = "SALES";
    ContactRole["CUSTOMER"] = "CUSTOMER";
})(ContactRole || (ContactRole = {}));
export var VisibilityMode;
(function (VisibilityMode) {
    VisibilityMode["VISIBLE"] = "VISIBLE";
    VisibilityMode["HIDDEN"] = "HIDDEN";
    VisibilityMode["TRANSPARENT"] = "TRANSPARENT";
})(VisibilityMode || (VisibilityMode = {}));
